import { useState } from 'react'

import { adminUpdateUserTransaction } from '@/actions/admin/transactionActions'
import { Transaction } from '@/reducers/admin/allTransactions.slice'
import { useAppDispatch } from '@/utils/typeHelpers'

export const useToggleTransactionClarification = ({
  transaction,
  onUpdated = () => undefined,
}: {
  transaction: Transaction
  onUpdated?: () => void
}) => {
  const dispatch = useAppDispatch()
  const [isUpdating, setUpdating] = useState(false)

  const toggleClarification = async () => {
    const requestedClarificationAt = transaction.requestedClarificationAt
      ? null
      : Date.now()
    setUpdating(true)
    const data = {
      requestedClarificationAt,
    }

    await adminUpdateUserTransaction(transaction.id, data)(dispatch)
    setUpdating(false)
    onUpdated()
  }

  return {
    isUpdating,
    toggleClarification,
  }
}
